export default __webpack_public_path__ + "static/media/December2017.59be9b29.png";